import React from 'react';

const FormControlMacho = ({ formDatos, setFormDatos }) => (
  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
    <div>
      <label className="block text-xs font-medium text-gray-700 mb-1">CE (cm) *</label>
      <input type="number" step="0.1" value={formDatos.ce || ''} onChange={(e) => setFormDatos(p => ({ ...p, ce: e.target.value }))}
        placeholder="34" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" data-testid="campo-ce" autoFocus />
    </div>
    <div>
      <label className="block text-xs font-medium text-gray-700 mb-1">Aptitud</label>
      <select value={formDatos.aptitud || ''} onChange={(e) => setFormDatos(p => ({ ...p, aptitud: e.target.value }))}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm">
        <option value="">Seleccionar</option>
        <option value="apto">Apto</option>
        <option value="no_apto">No Apto</option>
        <option value="diferido">Diferido</option>
      </select>
    </div>
    <div>
      <label className="block text-xs font-medium text-gray-700 mb-1">Libido</label>
      <select value={formDatos.libido || ''} onChange={(e) => setFormDatos(p => ({ ...p, libido: e.target.value }))}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" data-testid="campo-libido">
        <option value="">Seleccionar</option>
        <option value="alta">Alta</option>
        <option value="normal">Normal</option>
        <option value="baja">Baja</option>
      </select>
    </div>
    <div>
      <label className="block text-xs font-medium text-gray-700 mb-1">Conformacion</label>
      <select value={formDatos.conformacion || ''} onChange={(e) => setFormDatos(p => ({ ...p, conformacion: e.target.value }))}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm">
        <option value="">Seleccionar</option>
        <option value="excelente">Excelente</option>
        <option value="buena">Buena</option>
        <option value="regular">Regular</option>
        <option value="mala">Mala</option>
      </select>
    </div>
    <div>
      <label className="block text-xs font-medium text-gray-700 mb-1">Calidad Seminal</label>
      <select value={formDatos.calidad_seminal || ''} onChange={(e) => setFormDatos(p => ({ ...p, calidad_seminal: e.target.value }))}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" data-testid="campo-calidad-seminal">
        <option value="">Seleccionar</option>
        <option value="muy_buena">Muy Buena</option>
        <option value="buena">Buena</option>
        <option value="regular">Regular</option>
        <option value="mala">Mala</option>
      </select>
    </div>
    <div>
      <label className="block text-xs font-medium text-gray-700 mb-1">Motilidad (%)</label>
      <input type="number" min="0" max="100" value={formDatos.motilidad || ''} onChange={(e) => setFormDatos(p => ({ ...p, motilidad: e.target.value }))}
        placeholder="70" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
    </div>
    <div>
      <label className="block text-xs font-medium text-gray-700 mb-1">Concentracion (M/ml)</label>
      <input type="number" step="0.1" value={formDatos.concentracion || ''} onChange={(e) => setFormDatos(p => ({ ...p, concentracion: e.target.value }))}
        placeholder="500" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
    </div>
    <div>
      <label className="block text-xs font-medium text-gray-700 mb-1">Madurez Fisiologica (1-10)</label>
      <input type="number" min="1" max="10" value={formDatos.score_madurez || ''} onChange={(e) => setFormDatos(p => ({ ...p, score_madurez: e.target.value }))}
        placeholder="7" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" data-testid="campo-score-madurez" />
    </div>
    <div>
      <label className="block text-xs font-medium text-gray-700 mb-1">Madurez Sexual (1-10)</label>
      <input type="number" min="1" max="10" value={formDatos.score_sexual || ''} onChange={(e) => setFormDatos(p => ({ ...p, score_sexual: e.target.value }))}
        placeholder="7" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
    </div>
    <div>
      <label className="block text-xs font-medium text-gray-700 mb-1">Resist. Parasitos (1-10)</label>
      <input type="number" min="1" max="10" value={formDatos.score_parasitos || ''} onChange={(e) => setFormDatos(p => ({ ...p, score_parasitos: e.target.value }))}
        placeholder="7" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
    </div>
    <div>
      <label className="block text-xs font-medium text-gray-700 mb-1">Observaciones</label>
      <input type="text" value={formDatos.observaciones || ''} onChange={(e) => setFormDatos(p => ({ ...p, observaciones: e.target.value }))}
        placeholder="Notas..." className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
    </div>
  </div>
);

export default FormControlMacho;
